module.exports = __webpack_public_path__ + "media/images/contest-menu-label@3x-62879d733c7a9ce04b9eff28e177c052.png";